import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

export default function DialogLineAudioPlayer(props) {
   const { selected, mediaSrc, onEnded, paused } = props;

   const audioRef = useRef(null);

   useEffect(() => {
        if(!selected) return;

        if (paused) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
    }, [paused, selected])

   useEffect(() => {
        if(!selected) {
            audioRef.current.currentTime = 0;
            audioRef.current.pause();
            return;
        } else {
            audioRef.current.play();
        }
    }, [mediaSrc, selected])

    return (
        <audio
            ref={audioRef}
            src={mediaSrc}
            onEnded={() => onEnded()}
            type="audio/mpeg"
        />
    )
}

DialogLineAudioPlayer.propTypes = {
    mediaSrc: PropTypes.string.isRequired,
    onEnded: PropTypes.func.isRequired,
    paused: PropTypes.bool,
    selected: PropTypes.bool
}